module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "tiktok_black.a178600a.svg";